// Section for import npm components -----------------------------------------------------------------------------------
import React, { useEffect, useState, useRef, useContext } from 'react';

// MUI components
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

// Section for import custom components --------------------------------------------------------------------------------
import { AppConfigContext } from '@providers/AppConfigProvider';
import useGetElementProperty from '@hooks/useGetElementProperty';
import CommonUtility from '@utils/Common';

// Section for type definition -----------------------------------------------------------------------------------------
import CommonUtilityClass from '@/types/CommonUtilityClass';

type MansionInquiryProps = {
  estateHelpContactUrl: string;
};

const commonUtil: CommonUtilityClass = CommonUtility;

export default function MansionInquiry(props: MansionInquiryProps) {
  const { isMobile } = useContext(AppConfigContext);

  const targetRef = useRef(null);
  const { getElementProperty } = useGetElementProperty<HTMLDivElement>(targetRef);

  const [initialRect, setInitialRect] = useState(0);
  const [documentHeight, setDocumentHeight] = useState(0);
  const [switchHeight, setSwitchHeight] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const [isOpacity, setIsOpacity] = useState(false);

  const styleWrapper: string =
    'flex justify-center bottom-0 sticky md:mt-10 max-md:mx-0 max-md:px-5 max-md:py-[10px] bg-neutral-950/50';
  const styleBgPc: string = `py-3 `;
  const styleBgSp: string = `max-md:w-full `;
  const styleButtonPc: string = `relative group p-0 shadow-none `;
  const styleButtonSp: string = `relative group p-0 shadow-none w-full`;

  const { estateHelpContactUrl } = props;

  //  link to dotcom contact form
  // ----------------------------------------------
  /**
   * @return {void}
   */
  const onSubmit = (): void => {
    // console.log(estateHelpContactUrl);
    window.open(`${estateHelpContactUrl}`);
  };

  // show Element : footer-fix-cta
  /**
   * @return {void}
   */
  function showElement(): void {
    setIsVisible(true);
  }

  // hide Element : footer-fix-cta
  /**
   * @return {void}
   */
  function hideElement(): void {
    // @ts-ignore
    const hideHeight: number = Number(targetRef.current.getAttribute('data-switch-height'));

    // 切り替え時の高さを一度だけ記録する
    if (hideHeight === 0) {
      setSwitchHeight(window.scrollY);
    }
    setIsVisible(false);
  }

  const handleScroll = () => {
    // 初期表示時の高さを取得
    // @ts-ignore
    const targetRect: number = Number(targetRef.current.getAttribute('data-init-top'));

    // @ts-ignore
    const targetRectY: number = Number(getElementProperty('y'));

    const stateVisible: boolean = commonUtil.convertStringToBoolean(
      // @ts-ignore
      targetRef.current.getAttribute('data-state-visible'),
    );

    const stateMobile: boolean = commonUtil.convertStringToBoolean(
      // @ts-ignore
      targetRef.current.getAttribute('data-state-mobile'),
    );

    const isAboveTarget: boolean = stateMobile ? targetRectY < targetRect - 400 : targetRectY < targetRect;

    // @ts-ignore
    const hideHeight: number = Number(targetRef.current.getAttribute('data-switch-height'));

    const numSwitchHeight: number = hideHeight - targetRect > 0 ? hideHeight - targetRect : 0;
    const isBelowSwitchHeight: boolean = window.scrollY < numSwitchHeight;

    // const isInitialDisplay: boolean = targetRect === targetRectY && stateVisible;
    // console.log('----------------------------------------------');
    // console.log('isInitialDisplay', isInitialDisplay);
    // console.log('targetRect', targetRect);
    // console.log('targetRectY', targetRectY);
    // console.log('window.scrollY', window.scrollY);
    // console.log('numSwitchHeight', numSwitchHeight);
    // console.log('stateVisible', stateVisible);
    // console.log('isAboveTarget', isAboveTarget);
    // console.log('isBelowSwitchHeight', isBelowSwitchHeight);

    if (isAboveTarget && stateVisible) {
      hideElement();
      // console.log('============================================');
      // console.log('hide');
      // console.log('============================================');
    } else if (isAboveTarget && !stateVisible && isBelowSwitchHeight) {
      showElement();
    } else if (isAboveTarget && isBelowSwitchHeight) {
      showElement();
    }
  };

  useEffect(() => {
    const initialRectProperty: number = getElementProperty('y');
    setInitialRect(initialRectProperty);
    setDocumentHeight(document.documentElement.offsetHeight);

    if (isMobile) {
      window.addEventListener('touchstart', handleScroll);
      window.addEventListener('touchmove', handleScroll);
      // window.addEventListener('scroll', handleScroll);
    } else {
      window.addEventListener('scroll', handleScroll);
    }

    window.onscroll = function () {
      if(window.scrollY > 0){
        setIsOpacity(true);
      }
    }

    return () => {
      if (isMobile) {
        window.removeEventListener('touchstart', handleScroll);
        window.removeEventListener('touchend', handleScroll);
        // window.addEventListener('scroll', handleScroll);
      } else {
        window.removeEventListener('scroll', handleScroll);
      }
    };
  }, [isMobile]);

  return (
    <Box className={`${isVisible ? styleWrapper : 'hidden'} z-20 ${isOpacity ? 'opacity-100' : 'opacity-0'}`}>
      <Box
        className={`${isMobile ? styleBgSp : styleBgPc}`}
        ref={targetRef}
        data-state-mobile={`${isMobile ? 'true' : 'false'}`}
        data-state-visible={isVisible}
        data-init-top={initialRect}
        data-doc-height={documentHeight}
        data-switch-height={switchHeight}
      >
        <Button
          color="primary"
          variant="contained"
          size="large"
          onClick={onSubmit}
          className={`${isMobile ? styleButtonSp : styleButtonPc}`}
        >
          <Box className="rf-btn-lg-spMax">この物件が出たら教えて</Box>
        </Button>
      </Box>
    </Box>
  );
}
